import moment from 'moment';
import { parseDateRange/*, DATE_FORMAT*/ } from '../../src/ui/constants/marketdata'; 
import { MONTHS } from '../../src/chart/data/constants';
// const fetch = require('node-fetch');
const { URL, URLSearchParams } = require('url');
const hstri = require('hstri');

function fetchData(instrument, start, formattedStart, end, frequency, isPercent, product, isCustom, done) {
  const currentTime = moment();
  const token = getToken(product);
  const isIntraday = frequency.includes('T') && frequency.includes('M') || frequency.includes('H') || start.includes('D');
  if (start === 'YTD') {
    const dec31 = moment().subtract(1, 'year').month(11).date(31);
    queryHstri(formattedStart, instrument, 'P1D', dec31).then(yearEndData => {
      // find last trading session of previous year
      const lastDate = getLastDate(yearEndData);
      queryHstri(lastDate, instrument, frequency, end, token)
        .then(data => done(data));
    })
  } else if (isIntraday && !isCustom) {
    // count back to end of correct prior trading session
    const expandedStart = moment(formattedStart).subtract(5, 'day');
    queryHstri(expandedStart, instrument, 'PT1H', currentTime).then(intradayData => {
      const { timeValue } = parseDateRange(start);
      const startData = findStartTimes(intradayData, timeValue);
      const firstPointTime = getQueryStart(startData);
      queryHstri(firstPointTime, instrument, frequency, end, token)
        .then(data => done(data, startData));
    })
  } else {
    queryHstri(formattedStart, instrument, frequency, end, token)
      .then(data => done(data));
  }
}

// functions to export to api
// async function getTickerSymbolIndex(url) {
//   return await fetch(url); 
// }

function parseURL(req, type, currentTime) {
  const fullUrl = req.protocol + '://' + req.get('host') + req.originalUrl;
  const requestURL = new URL(fullUrl);
  const getSearchParams = createParamsSearch(requestURL);

  return type === 'ticker' ?
    getSearchParams('stockIndex')
    :
    getMikeParams(getSearchParams, currentTime);
}

function getToken(product) {
  switch (product) {
    case 'wsj':
      return '57494d5ed7ad44af85bc59a51dd87c90';
    case 'barrons':
      return 'c1b7ca756343461b86565b61bbd2ac6f';
    case 'marketwatch':
      return 'cecc4267a0194af89ca343805a3e57af';
    case 'mansionglobal':
      return '45mb4gzz6uqrogv7xgv37k654z2e5d6q';
    case 'financialnews':
      return 'brewtbcvblmff8sb1kcdbj21c29j8lv5';
    default:
      return '57494d5ed7ad44af85bc59a51dd87c90';
  }
// WSJ Pro: 'eb0af67ce7f24679a0e2d2c7c32e7d98'
}

function isCustomStart(start) {
  return start.length > 3;
}

function findStartDate(start) {
  return start[0] === 'Y' ?
    findYTDStart()
    :
    subtractDate(start);
}

function createDataFormatter(res, /*currentTime, */isPercent) {
  return function(data, startData) {
    // const date = currentTime.tz('America/New_York').format('MMM D h:mm a');
    const series = formatForChartlos(data, /*date, */isPercent, startData);
    res.send({ series });
  }
}

function queryHstri(start, instrument, frequency, end, entitlementToken) {
  return hstri({
    start: moment.tz(start, 'America/New_York'),
    instrument,
    frequency: frequency || 'P1D',
    end: moment.tz(end, 'America/New_York'),
    service: 'michelangelo',
    entitlementToken
  });
}

function getLastDate(res) {
  const { data } = res[0];
  return data[data.length - 1][0];
}

function findStartTimes(data, timeFrame) {
  const startTimes = {};
  data.forEach((series, index) => {
    const { ticker, raw } = series;
    const { MarketSessions, InstrumentType } = raw.Series[index];
    const sessions = MarketSessions.reverse();
    startTimes[ticker] = findStartTime(sessions, InstrumentType, timeFrame);
  })
  return startTimes;
}

function getQueryStart(startData) {
  // start date for hstri query is earliest start date among tickers
  const startTimes = Object.values(startData);
  return Math.min(...startTimes);
}

// parseURL helper functions
function createParamsSearch(requestURL) {
  return function (prop, getAll) {
    const action = getAll ? 'getAll' : 'get';
    return requestURL.searchParams[action](prop);
  }
}

function getMikeParams(getSearchParams, currentTime) {
  return ['instrument', 'start', 'end', 'frequency', 'format', 'product', 'type']
    .map(prop => getParam(getSearchParams, prop, currentTime));
}

function getParam(getSearchParams, prop, currentTime) {
  const param = getSearchParams(prop, prop === 'instrument');
  switch(prop) {
    case 'end':
      return param || currentTime;
    case 'format':
      return param === 'percent';
    case 'type':
      return param === 'rolling';
    default:
      return param;
  }
}

// findStartDate helper functions
function findYTDStart() {
  // check forward from 12/26 to find date of previous year's last trading session
  return moment().subtract(1, 'year').month(11).date(26);
}

function subtractDate(start) {
  const { timePeriodType, timeValue } = parseDateRange(start);
  const [timeType, multiplier] = timePeriodType === 'Y' ?
    ['weeks', 52] // 1Y = 52 weeks, etc.
    :
    [getTimeFrame(timePeriodType), 1];
  return moment().subtract(timeValue * multiplier, timeType);
}

function getTimeFrame(code) {
  switch (code) {
    case 'D':
      return 'days';
    case 'Y':
      return 'years';
    case 'M':
      return 'months';
  }
}

function dataGetter(res, isPercent, timeData = {}) {
  const isMultiple = res.length > 1;

  const showAsPercentProps = checkShowAsPercent(res, isPercent);
  const usePercent = isMultiple &&
    (isPercent || mustShowAsPercent(showAsPercentProps));

  return function(series, index) {
    const { ticker, data, raw, name } = series;
    const { TimeInfo, Series } = raw;
    const { IsIntraday: isIntraday, LastTick } = TimeInfo;
    const { InstrumentType: tickerType } = Series[index];

    const [seriesArr, categories] = mapSeriesData(data, isMultiple, usePercent, tickerType, timeData[ticker], isIntraday);
    const date = formatAsOfDate(LastTick, isIntraday);
    return [seriesArr, categories, date, showAsPercentProps];
  }
}

// createDataFormatter helper functions
function formatForChartlos(res, /*date, */isPercent, timeData) {
  const getData = dataGetter(res, isPercent, timeData);
  
  return res.map((series, index) => {
    const [seriesArr, categories, date, showAsPercentProps] = getData(series, index);
    const { raw, name, ticker } = series;
    const { TimeInfo, Series } = raw;
    const { IsIntraday: isIntraday } = TimeInfo;
    const {
      CountryCode: country,
      InstrumentType: tickerType,
      FormatHints/*,
      TimeZoneData*/
    } = Series[index];
    
    const sourceInfo = getSourceInfo(tickerType, ticker);
    const [prefix, decimals] = setFormatProps(FormatHints);
    const needsCommas = tickerType !== 'Index';
    
    return ({
      data: seriesArr,
      name,
      symbol: ticker,
      country,
      needsCommas,
      index,
      date,
      prefix,
      decimals,
      isIntraday,
      sourceInfo,
      tickerType,
      showAsPercentProps,
      categories
    })
  })
}

// function formatForChartlos(res, /*date, */isPercent, timeData) {
//   const isMultiple = res.length > 1;

//   const showAsPercentProps = checkShowAsPercent(res, isPercent);
//   const usePercent = isMultiple &&
//     (isPercent || mustShowAsPercent(showAsPercentProps));
  
//   return res.map((series, index) => {
    
//     const { ticker, data, raw, name } = series;
//     const { TimeInfo, Series } = raw;
//     const { IsIntraday: isIntraday, LastTick } = TimeInfo;
//     const {
//       CountryCode: country,
//       InstrumentType: tickerType,
//       FormatHints/*,
//       TimeZoneData*/
//     } = Series[index];

//     const [seriesArr, categories] = mapSeriesData(data, isMultiple, usePercent, tickerType, timeData[ticker], isIntraday);
//     const sourceInfo = getSourceInfo(tickerType, ticker);
//     const [prefix, decimals] = setFormatProps(FormatHints);
//     const needsCommas = tickerType !== 'Index';
//     const date = formatAsOfDate(LastTick, isIntraday);
    
//     return ({
//       data: seriesArr,
//       name,
//       symbol: ticker,
//       country,
//       needsCommas,
//       index,
//       date,
//       prefix,
//       decimals,
//       isIntraday,
//       sourceInfo,
//       tickerType,
//       showAsPercentProps,
//       categories
//     })
//   })
// }

function checkShowAsPercent(series, isPercentProp) {
  // "Show as percent change" toggle should be locked into true or false in certain situations
  const hasBonds = series.some(checkBonds);
  const differentUnitSymbols = series.some((currentSeries, i) =>
    checkUnitSymbols(series[0], currentSeries, i));
  const disabled = hasBonds || differentUnitSymbols// || series.length === 1;
  const isPercent = !hasBonds && (differentUnitSymbols || isPercentProp);
  return { isPercent, disabled };
}

function checkBonds(series, i) {
  const instrumentType = getSeriesProp(series, i, 'InstrumentType');
  return instrumentType === 'Bond';
}

function getSeriesProp(series, i, prop) {
  return series.raw.Series[i][prop];
}

function checkUnitSymbols(firstSeries, currentSeries, i) {
  return getUnitSymbol(currentSeries, i) !== getUnitSymbol(firstSeries, 0);
}

function getUnitSymbol(series, i) {
  return getSeriesProp(series, i, 'FormatHints').UnitSymbol;
}

function mustShowAsPercent(showAsPercentProps) {
  const { isPercent, disabled } = showAsPercentProps;
  return isPercent && disabled;
}

function mapSeriesData(data, isMultiple, usePercent, tickerType, startTime, isIntraday) {
  const seriesData = [],
    categories = [];

  const initialY = findFirstY(data);

  data.forEach((item, index) => {
    const x = item[0];
    
    const preStart = isMultiple && x < startTime;
    const y = getY(item[1], initialY, usePercent, tickerType, preStart);
    
    const category = formatCategory(x, isIntraday);
    
    seriesData.push({ index, x, y });
    categories.push(category);
  });

  return [seriesData, categories];
}

function findFirstY(data) {
  // find first non-null Y value (needed to calculate percent change)
  return data.find(point => point[1])[1];
}

function getY(y, initialY, usePercent, tickerType, preStart) {
  // for tickers from different time zones, don't plot ticker's Y values before its time frame starts
  if (preStart || y === null) return null;

  if (!usePercent || tickerType === 'Bond') return y;

  return getChange(initialY, y);
}

function getChange(initialY, y) {
  // percentage change from first Y value
  return (y - initialY) / initialY * 100;
}

function formatCategory(x, isIntraday) {
  const date = getETDate(x);
  const dayFormat = 'MM/DD/YYYY';
  return isIntraday ?
    date.format(`${dayFormat} h:mm:ss a`).slice(0, -1)
    :
    date.utc().format(dayFormat);
}

function getETDate(x) {
  return moment.tz(x, 'America/New_York');
}

function getSourceInfo(type, symbol) {
  return {
    source: getSource(type, symbol),
    type: getPlural(type),
    symbol
  }
}

function getSource(type, symbol) {
  switch(type) {
    case 'Bond':
    case 'Currency':
      return 'Tullett Prebon Information';
    case 'Index':
      return getIndexSource(symbol);
    case 'CryptoCurrency':
      return getCryptoSource(symbol);
    default:
      return 'SIX';
  }
}

function getIndexSource(symbol) {
  switch(symbol) {
    case 'BUXX':
    case 'NEXT50':
    case 'VCIPO':
      return 'Dow Jones Market Data';
    default:
      return 'SIX';
  }
}

function getCryptoSource(symbol) {
  switch(symbol) {
    case 'BTCEUR':
    case 'BTCUSD':
    case 'ETHEUR':
    case 'ETHUSD':
    case 'XRPEUR':
    case 'XRPUSD':
    case 'LTCEUR':
    case 'LTCUSD':
    case 'BCHEUR':
    case 'BCHUSD':
    case 'XMREUR':
    case 'XMRUSD':
    case 'ETCEUR':
    case 'ETCUSD':
    case 'DASHEUR':
    case 'DASHUSD':
    case 'ZECEUR':
    case 'ZECUSD':
      return 'KRAKEN';
    default:
      return 'CoinDesk';
  }
}

function getPlural(type) {
  switch(type){
    case 'Index':
      return 'indexes';
    case 'Commodity':
      return 'commodities';
    case 'CryptoCurrency':
      return 'crypto currencies';
    case 'Currency':
      return 'currencies';
    case 'ExchangeTradedFund':
      return 'ETFs';
    case 'ExchangeTradedNote':
      return 'ETNs';
    case 'Adr':
      return 'ADRs';
    case 'PreferredStock':
      return 'preferred stocks';
    // case 'MutualFundClosed':
    //   return;
    // case 'MutualFundOpen':
    //   return;
    // case 'RealEstateInvestmentTrust':
    //   return;
    default:
      return `${type.toLowerCase()}s`;
  }
}

function setFormatProps(formatHints) {
  const { UnitSymbol, DecimalPlaces } = formatHints;
  return UnitSymbol === '%' ?
    ['', DecimalPlaces] // bonds
    :
    [UnitSymbol || '', getDecimals(DecimalPlaces)];
}

function getDecimals(decimals) {
  return decimals > 2 ? 2 : decimals;
}

function formatAsOfDate(x, isIntraday) {
  const date = isIntraday ?
    getETDate(x)
    :
    getETDate(x).utc();
  const month = MONTHS[date.month()];
  const day = date.date();
  const formattedDate = `${month} ${day}`;
  const time = date.format('h:mm a');
  const formattedTime = isIntraday ?
    `, ${time.slice(0, -1)}.m. ET`
    :
    '';
  return formattedDate + formattedTime;
}

// findStartTimes helper functions
function findStartTime(sessions, instrumentType, timeFrame) {
  // remove all holidays before counting back correct number of days
  const holidaysRemoved = sessions.filter(session => session.Kind !== 'Holiday');
  return filterSessions(holidaysRemoved, instrumentType, timeFrame);
}

function filterSessions(holidaysRemoved, instrumentType, timeFrame) {
  const filter = checkClosed(holidaysRemoved) || instrumentType === 'Future' ?
    countBy24Hours : countClosedSessions;
  return filter(holidaysRemoved, timeFrame);
}

function checkClosed(sessions) {
  // check whether instrument has overnight closed session
  for (let i = 0; i < sessions.length; i++) {
    const { Kind, End, Start } = sessions[i];    
    if (Kind === 'Closed') {
      const closedLength = End - Start;
      const minute = 1000 * 60;
      const closed1Min = closedLength === minute;
      // const closed45Min = closedLength === minute * 45;
      if (closed1Min/* || closed45Min*/) return true;
    }
  }
  return false;
}

function countBy24Hours(sessions, timeFrame) {
  // for instruments without overnight closed sessions
  const tradingSessions = sessions.filter(session => session.Kind === 'Trading');
  const { End } = tradingSessions[0];
  const currentTimestamp = moment().valueOf();
  const tradingActive = currentTimestamp <= End;
  if (!tradingActive) timeFrame -= 1;
  const startingSession = tradingSessions[timeFrame];
  return tradingActive ?
    startingSession.End - (End - currentTimestamp)
    :
    startingSession.Start;
}

function countClosedSessions(sessions, timeFrame) {
  // because some markets close for lunch, count only overnight closed sessions
  for (var i = 0, count = 0; i < sessions.length - 1, count < timeFrame; i++) {
    const { End, Start, Kind } = sessions[i];
    const notLunch = End - Start > 1000 * 60 * 60 * 3;
    if (Kind === 'Closed' && notLunch && i > 0) {
      count++;
    }
  }
  return findFirstTradingSession(sessions.slice(i));
}

function findFirstTradingSession(sessions) {
  const firstTradingSession = sessions.find(session => session.Kind === 'Trading');
  return firstTradingSession.End;
}

export {
  parseURL,
  // getTickerSymbolIndex,
  getToken,
  isCustomStart,
  findStartDate,
  createDataFormatter,
  queryHstri,
  getLastDate,
  findStartTimes,
  getQueryStart,
  fetchData,
  dataGetter   
}


// WEBPACK FOOTER //
// ./server/shared/marketDataHelpers.js